import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { History, CheckCircle2, XCircle, MapPin } from "lucide-react";
import { apiClient } from "@/lib/apiClient";

const fmtTime = (iso) => {
  try { return new Date(iso).toLocaleString("de-CH", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" }); } catch { return iso; }
};
const METHOD = { password: "Passwort", code: "Einmal-Code", "2fa": "2FA", invite: "Einladung" };

/** Letzte Anmeldungen inkl. fehlgeschlagener Versuche: Gerät, Ort, Ergebnis. */
export default function LoginHistoryCard() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    apiClient.get("/auth/login-history?limit=50").then((r) => setItems(r.data || [])).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  const failed = items.filter((i) => !i.success).length;
  const shown = showAll ? items : items.slice(0, 10);

  return (
    <Card className="p-5 border border-slate-200 bg-white shadow-sm" data-testid="account-login-history-card">
      <div className="flex items-start gap-3 mb-4">
        <div className="h-10 w-10 rounded-lg bg-slate-100 text-slate-700 flex items-center justify-center flex-shrink-0">
          <History className="h-5 w-5" />
        </div>
        <div className="flex-1">
          <h2 className="text-lg font-semibold text-slate-900">Anmelde-Verlauf</h2>
          <p className="text-sm text-slate-500 mt-0.5">
            Die letzten Anmeldungen an deinem Konto – auch fehlgeschlagene Versuche.
            {failed > 0 && <span className="ml-1 text-rose-600 font-medium" data-testid="account-login-history-failed-count">{failed} fehlgeschlagen</span>}
          </p>
        </div>
      </div>
      {loading ? (
        <p className="text-sm text-slate-500">Lädt …</p>
      ) : items.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="account-login-history-empty">Noch keine Einträge.</p>
      ) : (
        <ul className="divide-y divide-slate-100" data-testid="account-login-history-list">
          {shown.map((e) => (
            <li key={e.id} className="py-2.5 flex items-start gap-3" data-testid={`account-login-event-${e.id}`}>
              {e.success ? <CheckCircle2 className="h-4 w-4 mt-0.5 text-emerald-600 shrink-0" /> : <XCircle className="h-4 w-4 mt-0.5 text-rose-600 shrink-0" />}
              <div className="flex-1 min-w-0">
                <div className="text-sm text-slate-900 flex flex-wrap items-center gap-x-2">
                  <span className="font-medium">{e.device_label}</span>
                  <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${e.success ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`}>{e.reason_label}</span>
                  <span className="text-xs text-slate-400">{METHOD[e.method] || e.method}</span>
                </div>
                <div className="text-xs text-slate-500 mt-0.5 flex flex-wrap gap-x-3">
                  <span>{fmtTime(e.at)}</span>
                  {(e.location || e.ip) && <span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3" />{e.location || "Ort unbekannt"}{e.ip ? ` · ${e.ip}` : ""}</span>}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
      {items.length > 10 && (
        <button type="button" className="mt-2 text-xs text-sky-700 hover:underline" onClick={() => setShowAll((v) => !v)} data-testid="account-login-history-toggle">
          {showAll ? "Weniger anzeigen" : `Alle ${items.length} anzeigen`}
        </button>
      )}
    </Card>
  );
}
